/**
 * RightSidebarTabs - 侧边栏评论切换组件
 *
 * 使用 Unpoly 编译器替代 Alpine.js，处理“精选”与“最新”评论的切换逻辑。
 */
export class RightSidebarTabs {
  static compiler(): void {
    up.compiler("[data-sidebar-tabs]", (container) => {
      const tabs = container.querySelectorAll<HTMLElement>("[data-tab-target]");
      const contents =
        container.querySelectorAll<HTMLElement>("[data-tab-content]");

      const switchTab = (activeId: string) => {
        // 更新 Tab 按钮样式
        tabs.forEach((tab) => {
          const targetId = tab.getAttribute("data-tab-target");
          const isActive = targetId === activeId;
          const indicator = tab.querySelector("[data-tab-indicator]");

          if (isActive) {
            tab.classList.add("text-primary");
            tab.classList.remove("text-muted-foreground", "hover:text-main");
            indicator?.classList.remove("scale-x-0");
            indicator?.classList.add("scale-x-100");
          } else {
            tab.classList.remove("text-primary");
            tab.classList.add("text-muted-foreground", "hover:text-main");
            indicator?.classList.remove("scale-x-100");
            indicator?.classList.add("scale-x-0");
          }
        });

        // 更新内容显示
        contents.forEach((content) => {
          const contentId = content.getAttribute("data-tab-content");
          if (contentId === activeId) {
            content.classList.remove("hidden");
            content.classList.add("reveal-content");
          } else {
            content.classList.add("hidden");
            content.classList.remove("reveal-content");
          }
        });
      };

      // 绑定点击事件
      tabs.forEach((tab) => {
        tab.addEventListener("click", () => {
          const targetId = tab.getAttribute("data-tab-target");
          if (targetId) switchTab(targetId);
        });
      });

      // 初始化：默认激活第一个有内容的 Tab
      const initialTab =
        container.getAttribute("data-initial-tab") || "featured";
      switchTab(initialTab);
    });
  }
}
